/**
 * Created by varunsharma on 12/03/18.
 */
    App.controller('homepageController', ['$scope','API','$location','$http','driverService','$rootScope',function( $scope,API,$location,$http,driverService,$rootScope) {

        history.pushState(null, null, location.href);
        window.onpopstate = function () {
            history.go(1);
        };

        $( window ).scroll(function() {
            // If user didn't scroll 1200px set default z-index
            if ($(this).scrollTop() < 100) {
                $("#dashboard-images" ).css( "z-index", 1000);
                $("#loginModal").css( "z-index", 998);
            } else {
                // If user scrolled 1200px change logo's z-index to 9999
                $("#dashboard-images" ).css( "z-index", 998);
                $("#loginModal").css( "z-index", 1000);
            }
        });

        $scope.err_msg = false;
        $scope.err_msg_show = false;
        $scope.terms_checkbox = false;
        localStorage.removeItem('access_token');
        localStorage.removeItem('loginData');
        $rootScope.showLogout = false;

        $scope.moveToAddDriver = function(){


            $scope.driver_phone_no = $('#mobile').intlTelInput("getNumber");
            localStorage.setItem('phone_no',$scope.driver_phone_no);
            var country_code =  $("#mobile").intlTelInput("getSelectedCountryData").dialCode;
            localStorage.setItem('country_code',country_code)
            if(!$scope.driver_phone_no || !country_code || !($('#mobile').intlTelInput("isValidNumber")))
            {
                $scope.err_msg = true;
                return;
            }
            else {
                var reqObj = {
                    phone_no:  $scope.driver_phone_no,
                    country_code: country_code,
                    os_version: '',
                    device_name: '',
                    device_token: ''

                }
                $scope.err_msg = false;
                driverService.generateOtp(reqObj).then(function(res){
                    if(res.data.flag == responseStatus.SUCCESS){
                        $scope.erro_msg_show = false;
                        localStorage.removeItem('currentTab');
                        localStorage.removeItem('nextTab');
                        localStorage.removeItem('currentTaskBar');
                        localStorage.removeItem('access_token');
                        $location.path('/details')
                    }
                    else{
                        $scope.err_msg_show = true;
                        $scope.error_message = res.data.message;
                    }

                })
                $scope.otp = '';
                $scope.otperror = '';

              //  $location.path('/driver');
            }
        }

        $scope.moveToAddVehicle = function(){
                $location.path('/vehicle');

        }

        $("#mobile").intlTelInput({
            utilsScript:'/bower_components/intl-tel-input/build/js/utils.js',
            initialCountry:"CA"
        })

        $scope.moveToAddDriverCheck = function (checked){
            if(checked){
                $scope.moveToAddDriver()
            }
        }


        $(function() {
            $('#mobile').on('keypress', function(e) {
                if(e.which == 43)
                    return true;
                if (e.which > 31 && (e.which < 48 || e.which > 57 || e.which == 32))
                    return false;
                return true;
            });
        });
        $rootScope.loading_custom = false;

        $scope.moveToTerms = function (){
            $location.path('/terms')
        }

        document.getElementById('logoShap').style.pointerEvents = 'auto';

    }])




